(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevich-hairline-women"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sevich-women-page')) {
  customElements.define('sevich-women-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
      const copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      const form = this.querySelector('.sw-form');
      const quantity = form.querySelector('[name=quantity]');
      const main = this.querySelector('.sw-main-image');
      const guide = this.querySelector('.sw-guide-dialog');
      const zoom = this.querySelector('.sw-zoom-dialog');
      const added = this.querySelector('.sw-added-dialog');
      const error = this.querySelector('.sw-error');
      const buttons = this.querySelectorAll('.sw-add');
      const selected = () => form.querySelector('[name=id]:checked');
      const photo = (src, alt) => { main.removeAttribute('srcset'); main.src = src; main.alt = alt; };
      const sync = () => {
        const v = selected();
        this.querySelectorAll('[data-shade-name]').forEach(el => el.textContent = v.dataset.name);
        this.querySelectorAll('[data-price]').forEach(el => el.textContent = v.dataset.price);
        this.querySelectorAll('[data-add-label]').forEach(el => el.textContent = v.dataset.available === 'true' ? copy.add : copy.sold);
        buttons.forEach(el => el.disabled = v.dataset.available !== 'true');
        const thumb = this.querySelector('[data-gallery=shade]');
        thumb.dataset.src = v.dataset.image;
        thumb.dataset.alt = v.dataset.name;
        thumb.querySelector('img').removeAttribute('srcset');
        thumb.querySelector('img').src = v.dataset.image;
        this.querySelectorAll('.sw-thumb').forEach(el => el.setAttribute('aria-pressed', String(el === thumb)));
        photo(v.dataset.image, v.dataset.name);
        const url = new URL(location.href);
        url.searchParams.set('variant', v.value);
        history.replaceState({}, '', url);
        error.hidden = true;
      };
      on(form, 'change', e => {if (e.target.name === 'id') sync();});
      this.querySelectorAll('[data-qty]').forEach(el => on(el, 'click', () => {quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(el.dataset.qty));}));
      on(quantity, 'change', () => {quantity.value = Math.max(1, parseInt(quantity.value, 10) || 1);});
      this.querySelectorAll('.sw-thumb').forEach(el => on(el, 'click', () => {photo(el.dataset.src, el.dataset.alt);this.querySelectorAll('.sw-thumb').forEach(t => t.setAttribute('aria-pressed', String(t === el)));}));
      on(this.querySelector('.sw-guide-trigger'), 'click', () => guide.showModal());
      on(this.querySelector('.sw-zoom'), 'click', () => {const img=zoom.querySelector('img');img.removeAttribute('srcset');img.src=main.src;img.alt=main.alt;zoom.showModal();});
      this.querySelectorAll('dialog').forEach(dialog => {on(dialog.querySelector('.sw-dialog-close'), 'click', () => dialog.close());on(dialog, 'click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
      on(this.querySelector('.sw-continue'), 'click', () => added.close());
      this.querySelectorAll('[data-pick]').forEach(el => on(el, 'click', () => {const input=form.querySelector('[value="'+el.dataset.pick+'"]');input.checked=true;sync();guide.close();input.focus();}));
      on(form, 'submit', async e => {
        e.preventDefault();
        if (this.busy || !form.reportValidity() || selected().dataset.available !== 'true') return;
        this.busy = true;
        const variant = selected();
        const amount = Math.max(1, parseInt(quantity.value,10) || 1);
        buttons.forEach(el => el.disabled = true);
        this.querySelectorAll('[data-add-label]').forEach(el => el.textContent = copy.adding);
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.value,quantity:amount}]}),credentials:'same-origin'});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || copy.error);
          this.querySelector('[data-added-detail]').textContent = variant.dataset.name+' / '+amount;
          const image=added.querySelector('img');image.removeAttribute('srcset');image.src=variant.dataset.image;image.alt=variant.dataset.name;
          added.querySelector('[data-price]').textContent=variant.dataset.price;
          added.showModal();
          try {const cartResponse=await fetch(this.dataset.cart,{credentials:'same-origin'});if(cartResponse.ok){const cart=await cartResponse.json();this.querySelectorAll('[data-cart-count]').forEach(el => el.textContent=cart.item_count);}}catch{}
        } catch(err) {error.textContent=err.message || copy.error;error.hidden=false;error.scrollIntoView({block:'nearest'});}
        finally {this.busy=false;const available=selected().dataset.available==='true';buttons.forEach(el => el.disabled=!available);this.querySelectorAll('[data-add-label]').forEach(el => el.textContent=available?copy.add:copy.sold);}
      });
      const demo=this.querySelector('.sw-demo-animation');
      const motion=this.querySelector('.sw-motion');
      const setMotion=playing=>{
        demo.src=playing?demo.dataset.animation:demo.dataset.poster;
        motion.setAttribute('aria-pressed',String(playing));
        motion.setAttribute('aria-label',playing?copy.pause:copy.play);
        motion.querySelector('[data-motion-icon]').textContent=playing?'\u275a\u275a':'\u25b6';
      };
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)setMotion(false);
      on(motion,'click',()=>setMotion(motion.getAttribute('aria-pressed')!=='true'));
      const sticky=this.querySelector('.sw-sticky');
      this.observer=new IntersectionObserver(entries => {sticky.hidden=entries[0].isIntersecting;},{threshold:0});
      this.observer.observe(form);
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
